import { useState } from "react";
import SbuxDialog2 from "../../../../components/SbuxDialog2";
import SbuxTranslate from "../../../../components/SbuxTranslate";
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
} from "@mui/material";
import DatePicker from "react-datepicker";
import dayjs from "../../../../utils/dayjs";
import styles from "../styles";
import useCss from "../../../../hooks/useCss";

interface Props {
  title: string;
  open: boolean;
  handleCustomFilterOkClick: (fromDate: Date, toDate: Date) => void;
  toggleOpen: () => void;
}

const ClosureMsgCustomFilter = ({
  title,
  open,
  handleCustomFilterOkClick,
  toggleOpen,
}: Props) => {
  const classes = useCss(styles);
  const [fromDate, setFromDate] = useState<Date>(new Date());
  const [toDate, setToDate] = useState<Date>(new Date());

  const handleFromDateChange = (value: Date | null) => {
    if (value) {
      setFromDate(value);
      setToDate(value);
    }
  };
  const handleToDateChange = (value: Date | null) => {
    if (value) setToDate(value);
  };

  const handleCustomOkClick = () => {
    handleCustomFilterOkClick(fromDate, toDate);
    toggleOpen();
  };

  const dialogConfig = {
    title,
    hasBackdrop: false,
    asModal: true,
    disableBackdropClose: false,
  };

  return (
    <SbuxDialog2 open={open} config={dialogConfig} handleOnClose={toggleOpen}>
      <DialogContent dividers>
        <Box component="form" className={classes.customFilterForm}>
          <Box>
            <FormControl>
              <InputLabel>
                <SbuxTranslate>{`From`}</SbuxTranslate>
              </InputLabel>
              <DatePicker
                className={classes.datePicker}
                selected={fromDate}
                minDate={dayjs().subtract(90, "days").toDate()}
                onChange={(date) => handleFromDateChange(date)}
                dateFormat="MM/dd/yyyy"
                popperProps={{ strategy: "fixed" }}
              />
            </FormControl>
          </Box>

          <Box>
            <FormControl>
              <InputLabel>
                <SbuxTranslate>{`To`}</SbuxTranslate>
              </InputLabel>
              <DatePicker
                className={classes.datePicker}
                selected={toDate}
                minDate={dayjs(fromDate).add(1, "days").toDate()}
                maxDate={dayjs(fromDate).add(31, "days").toDate()}
                onChange={(date) => handleToDateChange(date)}
                dateFormat="MM/dd/yyyy"
                popperProps={{ strategy: "fixed" }}
              />
            </FormControl>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Box className="actionContainer">
          <Button
            variant="contained"
            size="medium"
            onClick={handleCustomOkClick}
          >
            <SbuxTranslate>{`Okay`}</SbuxTranslate>
          </Button>
          <Button variant="outlined" size="medium" onClick={toggleOpen}>
            <SbuxTranslate>{`Cancel`}</SbuxTranslate>
          </Button>
        </Box>
      </DialogActions>
    </SbuxDialog2>
  );
};

export default ClosureMsgCustomFilter;
